module.exports = __webpack_public_path__ + "static/media/mm.92e9f832.svg";